import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import "./ContactCard.css";

const ContactCard = () => {
  return (
    <div className="contact-card  text-light p-4 rounded">
      <h3><b>Contact Us</b></h3>
      <p>
        <i className="fas fa-map-marker-alt"></i> Address<br />
        295 Witting Streets Suite 666,<br />
        Melbourne, Australia
      </p>
      <p>
        <i className="fas fa-phone"></i> Phone<br />
        (01) 479-642-7461<br />
        (01) 479-642-7462
      </p>
      <p>
        <i className="fas fa-envelope"></i> Email<br />
       Chitrakoot@hotmail.com<br />
        hello@hotmail.com
      </p>
    </div>
  );
};

export default ContactCard;
